import type { TopBannerListModel } from 'autogen/swagger/all';
import CarouselList from 'components/Streamers/carouselList';

type StreamersProps = {
    model: TopBannerListModel;
};

function Streamers({ model }: StreamersProps): JSX.Element {
    const { topBanners } = model;

    return <CarouselList topBanners={topBanners} />;
}

export default Streamers;
